import { setActiveTab } from '../State/activeTab';
import { clearSearchTerm } from '../State/searchTerm';

export default (activeTab) => async (dispatch) => {

  dispatch(setActiveTab(activeTab));
  dispatch(clearSearchTerm());

}